import { createApp } from 'vue'
import { renderZataReviewForm } from '~/js/zeta/review'
import { scrollStickyHeader } from '~/js/helpers/scroll'

const ID_ORDER_REVIEW_POST = 'js-orderReviewPost'
const CLASS_NAME_ZV_FORM = 'zv-form'
const QUERY_ZV_SUBMIT_WRAP = '.zv-submit-wrap'

const FORM_STATUS = {
  hidden: 'hidden',
  open: 'open',
  completed: 'completed',
}

document.addEventListener('DOMContentLoaded', async () => {
  const element = document.getElementById(ID_ORDER_REVIEW_POST)
  if (!element) return

  await renderZataReviewForm(element)
  createApp({
    name: 'TemplatesCustomersOrderReview',
    data() {
      return {
        formStatuses: [],
      }
    },
    mounted() {
      const elementsZvForm = element.getElementsByClassName(CLASS_NAME_ZV_FORM)
      Array.from(elementsZvForm).forEach((elementZvForm, index) => {
        this.formStatuses[index] = FORM_STATUS.hidden

        const setFormEvent = () => {
          const elementSubmitWrap =
            elementZvForm.querySelector(QUERY_ZV_SUBMIT_WRAP)
          const setStatusComplete = () => {
            if (elementSubmitWrap.innerText.includes('完了')) {
              scrollStickyHeader(elementZvForm.closest('li'))
              this.formStatuses[index] = FORM_STATUS.completed
            }
          }
          const observer = new MutationObserver(setStatusComplete)
          observer.observe(elementSubmitWrap, { childList: true })
        }

        const observer = new MutationObserver(setFormEvent)
        observer.observe(elementZvForm, { childList: true })
      })
    },
    methods: {
      isCompleted(index) {
        return this.formStatuses[index] === FORM_STATUS.completed
      },
      onReviewButtonClicked(index) {
        this.formStatuses[index] = FORM_STATUS.open
      },
      shouldShowReviewButton(index) {
        return this.formStatuses[index] === FORM_STATUS.hidden
      },
      shouldShowForm(index) {
        return this.formStatuses[index] === FORM_STATUS.open
      },
    },
  }).mount(element)
})
